import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DeviceTokenService {
  private readonly KEY = 'backoffice_device_token';

  constructor() {}

  getOrCreateDeviceToken(): string {
    const existing = this.safeGet(this.KEY);
    if (existing) return existing;

    const token = this.generateUuidV4();
    this.safeSet(this.KEY, token);
    return token;
  }

  rotateDeviceToken(): string {
    const token = this.generateUuidV4();
    this.safeSet(this.KEY, token);
    return token;
  }

  private safeGet(key: string): string | null {
    try {
      const value = localStorage.getItem(key);
      return value && value.trim().length > 0 ? value : null;
    } catch {
      return null;
    }
  }

  private safeSet(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      // localStorage no disponible (modo privado / políticas del navegador).
      // El login continúa; el device_token no será persistente en este caso.
    }
  }

  private generateUuidV4(): string {
    const cryptoApi = globalThis.crypto as Crypto | undefined;

    if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();

    // Fallback seguro: RFC4122 v4 con getRandomValues
    if (cryptoApi?.getRandomValues) {
      const bytes = new Uint8Array(16);
      cryptoApi.getRandomValues(bytes);

      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;

      const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');

      return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    }

    return `fallback-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }
}
